"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = exports.numberRegex = void 0;
var React = __importStar(require("react"));
var City_1 = __importDefault(require("./City"));
var StreetName_1 = __importDefault(require("./StreetName"));
var StreetNumber_1 = __importDefault(require("./StreetNumber"));
var ZipCode_1 = __importDefault(require("./ZipCode"));
var Floor_1 = __importDefault(require("./Floor"));
var Household_1 = __importDefault(require("./Household"));
var NameOnDoor_1 = __importDefault(require("./NameOnDoor"));
var pinata_1 = require("@snoam/pinata");
var isEqual = require("react-fast-compare");
exports.numberRegex = /^\d+$/;
var Address = (function (_super) {
    __extends(Address, _super);
    function Address(props) {
        var _this = _super.call(this, props) || this;
        _this.streetUpdated = function (street) {
            var isNewStreet = !isEqual(street, _this.state.street);
            var _a = isNewStreet ? {
                streetNumber: {},
                floor: {},
                houseHold: {},
            } : _this.props, streetNumber = _a.streetNumber, floor = _a.floor, houseHold = _a.houseHold;
            _this.setState({ street: street, streetNumber: streetNumber, floor: floor, houseHold: houseHold });
            _this.addressUpdated(__assign(__assign({}, _this.state), { street: street, streetNumber: streetNumber, floor: floor, houseHold: houseHold }));
        };
        _this.streetNumberUpdated = function (streetNumber) {
            _this.setState({ streetNumber: streetNumber });
            _this.addressUpdated(__assign(__assign({}, _this.state), { streetNumber: streetNumber }));
        };
        _this.floorUpdated = function (floor) {
            _this.setState({ floor: floor });
            _this.addressUpdated(__assign(__assign({}, _this.state), { floor: floor }));
        };
        _this.householdUpdated = function (houseHold) {
            _this.setState({ houseHold: houseHold });
            _this.addressUpdated(__assign(__assign({}, _this.state), { houseHold: houseHold }));
        };
        _this.nameOnDoorUpdated = function (nameOnDoor) {
            _this.setState({ nameOnDoor: nameOnDoor });
            _this.addressUpdated(__assign(__assign({}, _this.state), { nameOnDoor: nameOnDoor }));
        };
        _this.zipCodeUpdated = function (zipCode) {
            var streetNumber = __assign({}, _this.state.streetNumber);
            streetNumber.postalCode = zipCode;
            _this.setState({ validZip: true, streetNumber: streetNumber });
            _this.addressUpdated(__assign(__assign({}, _this.state), { streetNumber: streetNumber }));
        };
        _this.cityUpdated = function (city) {
            var street = __assign({}, _this.state.street);
            street.city = city;
            _this.setState({ validCity: true, street: street });
            _this.addressUpdated(__assign(__assign({}, _this.state), { street: street }));
        };
        _this.addressUpdated = function (address) {
            _this.props.addressUpdated && _this.props.addressUpdated(address);
        };
        var street = props.street, streetNumber = props.streetNumber, floor = props.floor, houseHold = props.houseHold, nameOnDoor = props.nameOnDoor;
        _this.state = {
            street: street,
            streetNumber: streetNumber,
            floor: floor,
            houseHold: houseHold,
            nameOnDoor: nameOnDoor,
            validCity: false,
            validZip: false
        };
        return _this;
    }
    Address.prototype.UNSAFE_componentWillReceiveProps = function (nextProps, nextContext) {
        var nextStreet = nextProps.street, nextFloor = nextProps.floor, nextHousehold = nextProps.houseHold, nextNameOnDoor = nextProps.nameOnDoor, nextStreetNumber = nextProps.streetNumber;
        var _a = this.state, street = _a.street, floor = _a.floor, houseHold = _a.houseHold, nameOnDoor = _a.nameOnDoor, streetNumber = _a.streetNumber;
        var state = { street: street, floor: floor, houseHold: houseHold, nameOnDoor: nameOnDoor, streetNumber: streetNumber };
        if (!isEqual(street, nextStreet)) {
            state.street = nextStreet;
        }
        if (!isEqual(floor, nextFloor)) {
            state.floor = nextFloor;
        }
        if (!isEqual(houseHold, nextHousehold)) {
            state.houseHold = nextHousehold;
        }
        if (!isEqual(nameOnDoor, nextNameOnDoor)) {
            state.nameOnDoor = nextNameOnDoor;
        }
        if (!isEqual(streetNumber, nextStreetNumber)) {
            state.streetNumber = nextStreetNumber;
        }
        if (!isEqual(this.state, state)) {
            this.setState(state);
        }
    };
    Address.prototype.render = function () {
        var _a = this.state, street = _a.street, streetNumber = _a.streetNumber, floor = _a.floor, nameOnDoor = _a.nameOnDoor, houseHold = _a.houseHold;
        var streetIds = street.streetIds && street.streetIds || undefined;
        var _b = this.props, inputsClearable = _b.inputsClearable, onSubmit = _b.onSubmit, submitButton = _b.submitButton, disabledZipAndCity = _b.disabledZipAndCity, showErrors = _b.showErrors;
        return (React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
                onSubmit && onSubmit();
            }, autoComplete: "off" },
            React.createElement("input", { style: { opacity: 0, position: 'absolute' }, tabIndex: -1 }),
            React.createElement(pinata_1.Grid, null,
                React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_12, pinata_1.GridSpan.SMALL_9, pinata_1.GridSpan.MEDIUM_9, pinata_1.GridSpan.LARGE_9] },
                    React.createElement(StreetName_1.default, { street: street, updateStreetName: this.streetUpdated, showErrors: showErrors })),
                React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_12, pinata_1.GridSpan.SMALL_3, pinata_1.GridSpan.MEDIUM_3, pinata_1.GridSpan.LARGE_3] },
                    React.createElement(StreetNumber_1.default, { streetNumber: streetNumber, streetIds: streetIds, updateStreetNumber: this.streetNumberUpdated, showErrors: showErrors })),
                floor && React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_6, pinata_1.GridSpan.SMALL_6, pinata_1.GridSpan.MEDIUM_6, pinata_1.GridSpan.LARGE_6] },
                    React.createElement(Floor_1.default, { floor: floor, updateFloor: this.floorUpdated, deliveryPointId: streetNumber.deliveryPointId, showErrors: showErrors })),
                houseHold && React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_6, pinata_1.GridSpan.SMALL_6, pinata_1.GridSpan.MEDIUM_6, pinata_1.GridSpan.LARGE_6] },
                    React.createElement(Household_1.default, { houseHold: houseHold, updateHousehold: this.householdUpdated, deliveryPointId: streetNumber.deliveryPointId, floor: floor, showErrors: showErrors })),
                React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_6, pinata_1.GridSpan.SMALL_6, pinata_1.GridSpan.MEDIUM_6, pinata_1.GridSpan.LARGE_6] },
                    React.createElement(ZipCode_1.default, { zipCode: streetNumber.postalCode, updateZipCode: this.zipCodeUpdated, clearable: inputsClearable, disabled: disabledZipAndCity, showErrors: showErrors })),
                React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_6, pinata_1.GridSpan.SMALL_6, pinata_1.GridSpan.MEDIUM_6, pinata_1.GridSpan.LARGE_6] },
                    React.createElement(City_1.default, { cityName: street.city || '', updateCity: this.cityUpdated, clearable: inputsClearable, disabled: disabledZipAndCity, showErrors: showErrors })),
                React.createElement(pinata_1.GridItem, { span: [pinata_1.GridSpan.XSMALL_12, pinata_1.GridSpan.SMALL_12, pinata_1.GridSpan.MEDIUM_12, pinata_1.GridSpan.LARGE_12] },
                    React.createElement(NameOnDoor_1.default, { clearable: inputsClearable, updateNameOnDoor: this.nameOnDoorUpdated, nameOnDoor: nameOnDoor, showErrors: showErrors }))),
            submitButton && submitButton));
    };
    Address.defaultProps = {
        street: {},
        streetNumber: {},
        floor: {},
        houseHold: {},
        nameOnDoor: '',
        inputsClearable: false,
        disabledZipAndCity: false,
        showErrors: true,
    };
    return Address;
}(React.PureComponent));
exports.Address = Address;
//# sourceMappingURL=Address.js.map